import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createDragDropManager } from "dnd-core";
import RevisionsAttributes from "./0_Revisions";
import { FieldArray } from "react-final-form-arrays";
export { getColsAttributes, fetchRequiredFormFieldData } from "./shared";

// One manager for the whole module — avoids "Cannot have two HTML5 backends" on remount/HMR
const dndManager = createDragDropManager(HTML5Backend);

const FormBuilder = ({ name, ...rest }) => {
  return (
    <DndProvider manager={dndManager}>
      <FieldArray name="revisions_attributes" component={RevisionsAttributes} subscription={{ length: true, value: true }} {...rest} />
    </DndProvider>
  );
};

export default FormBuilder;
